import ApiService from "../../util/ApiService";
import {
  GET_ALERTS_REQUEST,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_ERROR,
  CACHE_PREVIOUS_CATEGORY_IDS,
} from "../../constants/actionTypes";
import isEmpty from "lodash/isEmpty";

export const fetchAlerts = async (dispatch, categoryIds) => {
  dispatch({ type: GET_ALERTS_REQUEST });
  const ids = categoryIds || [];
  try {
    const filter = ids.length > 0 ? `&categories=${ids.join(",")}` : "";
    const response = await ApiService.get(
      `/v1/alerts?limit=50&type=all&ppcDataset=false${filter}`
    );
    dispatch({ type: GET_ALERTS_SUCCESS, payload: response.data });
    if (!isEmpty(ids)) {
      dispatch({ type: CACHE_PREVIOUS_CATEGORY_IDS, payload: ids });
    }
  } catch (e) {
    dispatch({ type: GET_ALERTS_ERROR });
  }
};
